export const Attributes = ["name", "email", "phone", "timezone", "gender", "city", "region", "country", "department"];

export const BoardAttributes = [
    "message",
    "score",
    "failures",
    "email",
    "phone",
    "name",
    "username",
    "source",
    "language",
    "timezone",
    "region",
    "country",
    "referrer",
    "url",
    "ip",
    "city",
    "lastSeen",
    "userId",
    "department",
];

export const Entities = ["any", "alphanumeric", "email", "integer", "no", "number", "phone", "url", "yes", "yesNo"];
export const EntityTypes = {
    ANY: {
        value: "any",
        name: "Any",
        description: "Matches anything that is non-empty",
    },
    ANYTEXT: {
        value: "anytext",
        name: "Any Text",
        description: "Matches any text without any number or special character",
    },
    ALPHANUMERIC: {
        value: "alphanumeric",
        name: "Alphanumeric",
        description: "Matches both letters and numerals",
    },
    EMAIL: {
        value: "email",
        name: "Email",
        description: "Matches e-mail",
    },
    INTEGER: {
        value: "integer",
        name: "Integer",
        description: "Matches an integer number",
    },
    NO: {
        value: "no",
        name: "No",
        description: "Matches no synonyms",
    },
    NUMBER: {
        value: "number",
        name: "Number",
        description: "Matches ordinal and cardinal number",
    },
    PHONE: {
        value: "phone",
        name: "Phone Number",
        description: "Matches phone number",
    },
    URL: {
        value: "url",
        name: "URL",
        description: "Matches URL",
    },
    YES: {
        value: "yes",
        name: "Yes",
        description: "Matches yes synonyms",
    },
    YES_NO: {
        value: "yesNo",
        name: "Yes - No",
        description: "Matches yes and no synonyms",
    },
    REGEX: {
        value: "regex",
        name: "Regex",
        description: "Matches via regex",
    },
};
